import React, { useEffect, useState } from 'react';
import SimpleModal from './SimpleModal';
import Input from './Input';
import Button from './Button';
import { animalEmojis } from '../utils/constants';
import './PlayerManagement.css';

function PlayerModal({
  isOpen,
  mode = 'create', // 'create' | 'edit'
  title,
  initialName = '',
  initialAge = '', // string or number
  initialEmoji = '🐶',
  isSubmitting = false,
  onClose,
  onSubmit, // async ({ name, age, emoji }) => void
  deleteAction, // optional: { text, onClick, disabled }
}) {
  const [name, setName] = useState(initialName || '');
  const [age, setAge] = useState(
    typeof initialAge === 'number' ? String(initialAge) : initialAge || ''
  );
  const [emoji, setEmoji] = useState(initialEmoji || '🐶');

  // Reset state when opening with new initial values
  useEffect(() => {
    if (isOpen) {
      setName(initialName || '');
      setAge(
        typeof initialAge === 'number' ? String(initialAge) : initialAge || ''
      );
      setEmoji(initialEmoji || '🐶');
    }
  }, [isOpen, initialName, initialAge, initialEmoji]);

  const effectiveTitle =
    title || (mode === 'edit' ? 'Edit Player' : 'Create New Player');
  const primaryLabel =
    mode === 'edit'
      ? isSubmitting
        ? 'Saving…'
        : 'Save'
      : isSubmitting
      ? 'Creating…'
      : 'Create Player';

  const actions = [
    deleteAction && mode === 'edit'
      ? {
          text: deleteAction.text || 'Delete',
          type: 'danger',
          onClick: deleteAction.onClick,
          disabled: deleteAction.disabled || isSubmitting,
        }
      : null,
    {
      text: 'Cancel',
      type: 'secondary',
      onClick: onClose,
      disabled: isSubmitting,
    },
    {
      text: primaryLabel,
      type: 'primary',
      onClick: async () => {
        if (!name.trim()) return;
        const ageNum = age ? parseInt(age, 10) : null;
        await onSubmit?.({
          name: name.trim(),
          age: isNaN(ageNum) ? null : ageNum,
          emoji,
        });
      },
      disabled: isSubmitting || !name.trim(),
    },
  ].filter(Boolean);

  return (
    <SimpleModal
      isOpen={isOpen}
      onClose={onClose}
      title={effectiveTitle}
      actions={actions}
    >
      <div className='emoji-selector'>
        <label>Choose Avatar:</label>
        <div className='emoji-grid'>
          {animalEmojis.map((item, index) => (
            <button
              key={index}
              type='button'
              className={`emoji-option ${emoji === item ? 'selected' : ''}`}
              onClick={() => setEmoji(item)}
            >
              {item}
            </button>
          ))}
        </div>
      </div>

      <div className='player-modal-inputs'>
        <Input
          type='text'
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Enter player's name"
          maxLength={20}
          disabled={isSubmitting}
          required
        />
        <Input
          type='tel'
          value={age}
          onChange={(e) =>
            setAge(e.target.value.replace(/\D/g, '').slice(0, 2))
          }
          placeholder='Age'
          maxLength={2}
          disabled={isSubmitting}
        />
      </div>
    </SimpleModal>
  );
}

export default PlayerModal;
